import React from "react";
import styled from "styled-components";
import { Trans, useTranslation } from "react-i18next";
import { Button, ButtonGroup } from "components/bootstrap";
import { Icon, HoverForHelp } from "components/common";
const Container = styled.div`
  display: flex;
  align-items: center;
`;
const StyledButtonGroup = styled(ButtonGroup)`
  margin-left: 5px;
`;
const StyledButtonBar = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const SearchFilterHelp = styled((props) => /* @__PURE__ */ React.createElement(HoverForHelp, { ...props }))`
  margin-left: 5px;
`;
export const SearchFilterExplanation = () => {
  const { t } = useTranslation("search");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "search_filter_banner.explanation", components: { italic: /* @__PURE__ */ React.createElement("i", null), bold: /* @__PURE__ */ React.createElement("b", null) } })), /* @__PURE__ */ React.createElement("p", null, t("search_filter_banner.explanation_saved")));
};
const SearchFilterBanner = ({ onHide, pluggableControls }) => {
  const { t } = useTranslation("search");
  const hasSearchFiltersPlugin = !!pluggableControls.find((control) => control.id === "search-filters");
  if (hasSearchFiltersPlugin) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Container, null, t("search_bar.filters_label"), /* @__PURE__ */ React.createElement(SearchFilterHelp, { title: t("search_bar.filters_tooltip_title"), trigger: ["click"] }, /* @__PURE__ */ React.createElement(SearchFilterExplanation, null), /* @__PURE__ */ React.createElement("p", null, t("search_bar.filters_enterprise_hint")), /* @__PURE__ */ React.createElement(StyledButtonBar, null, /* @__PURE__ */ React.createElement(Button, { onClick: onHide, bsSize: "xs" }, t("search_bar.filters_hide_controls")))), /* @__PURE__ */ React.createElement(StyledButtonGroup, null, /* @__PURE__ */ React.createElement(Button, { disabled: true, bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "add" })), /* @__PURE__ */ React.createElement(Button, { disabled: true, bsSize: "small" }, /* @__PURE__ */ React.createElement(Icon, { name: "folder" }))));
};
export default SearchFilterBanner;
